import React, { Component } from "react";
import { withNamespaces } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMale, faSearch } from "@fortawesome/free-solid-svg-icons";
import Skeleton from "react-loading-skeleton";
import { AiFillPlusCircle } from "react-icons/ai";

import DateTimePicker from "../../components/DateTimePicker/DateTimePicker";
import StringInput from "../../components/Input/StringInput/StringInput";
// import NumberInput from "../../components/Input/NumberInput/NumberInput";
import Button from "../../components/Button/Button";
import DataTable from "../../components/Datatable/DataTable";
import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import Lightbox from 'react-image-lightbox';

class SlotFreeSpinListing extends Component
{
    /* ============ component lifecycle [START] ============ */
    constructor(props)
    {
        super(props);
        this.state =
        {
            isOpen: false,
            currentImage: null,
        };
    }
    /* ============ component lifecycle [END] ============ */

    render()
    {
        const { t } = this.props;
        let permission = this.props.currentUser.permission ? this.props.currentUser.permission : [];

        /* ======================== datatables data assign [START] ======================== */
        const columns = [
            {
                text: t('global.no'),
                dataField: "",
                formatter: (cell, row, rowIndex) =>
                {
                    let rowNumber = (this.props.totalRecords - rowIndex - ((this.props.activePage - 1) * this.props.limit));
                    return <span>{rowNumber}</span>;
                },
                headerStyle: () => {
                    return {width: '60px'};
                }
            },
            {
                text: t('global.id'),
                dataField: "id",
                sort: true,
                onSort: this.props.onSort,
                // hidden: true
            },
            { 
                text: t("slot-free-spin.game-vendor"), 
                dataField: "vendor", 
                sort: true, 
                onSort: this.onSort,
                formatter: (cell, row) => 
                {
                    return <span>{t(`vendor.${row.vendor}`)}</span>;
                },         
            },
            { 
                text: t("slot-free-spin.reference-code"), 
                dataField: "reference_code", 
                sort: true, 
                onSort: this.onSort,
                // formatter: (cell, row) => 
                // {
                //     return <b><a href="/#" onClick={(event) => this.props.detailsHandler(event, row.id)}>
                //                 {row.reference_code}
                //                 <i className="fas fa-external-link-square-alt text-primary ml-1"></i>
                //             </a></b>;
                // },
            },
            { 
                text: t("global.status"), 
                dataField: "status", 
                sort: true, 
                onSort: this.onSort,
                formatter: (cell, row) => 
                {
                    return <span>{t(`transaction.status-desc.${row.status}`)}</span>;
                },
            },
            { 
                text: t('global.created-time'), 
                dataField: "create_date", 
                sort: true, 
                onSort: this.onSort,
            },
            // { 
            //     text: t('global.updated-time'), 
            //     dataField: "update_date", 
            //     sort: true, 
            //     onSort: this.onSort,
            // },
            { 
                text: t('global.updated-by'), 
                dataField: "update_by", 
                sort: true, 
                onSort: this.onSort,
            },
            {
                text: t('global.action'),
                dataField: "#",
                keyField: "action",
                formatter: (cell, row) =>
                {
                    let editButton, groupButton, viewButton, output;
                    // if (permission.includes("slot_free_spin_access")) {
                    //     editButton = (
                    //         <Button
                    //             typeButton="button"
                    //             classValue="btn btn-sm btn-white m-1"
                    //             key={`edit-${row.batch_no}`}
                    //             idValue={row.batch_no === undefined ? 0 : row.batch_no}
                    //             clicked={(event) => this.editHandler(event, row.batch_no)}
                    //             buttonName={<FontAwesomeIcon icon={faPen} />}
                    //         />
                    //     );
                    // }

                    if (permission.includes("slot_free_spin_create")) {
                        groupButton = (
                            <Button
                                typeButton="button"
                                classValue="btn btn-sm btn-white m-1"
                                key={`edit-${row.voucherID}`}
                                idValue={row.voucherID === undefined ? 0 : row.voucherID}
                                clicked={(event) => this.props.addMemberHandler(event, 'add_member', row)}
                                buttonName={<FontAwesomeIcon icon={faMale} />}
                            />
                        );
                    }

                    if (permission.includes("slot_free_spin_access")) {
                        viewButton = (
                            <Button
                                typeButton="button"
                                classValue="btn btn-sm btn-white mr-1"
                                buttonName={<FontAwesomeIcon icon={faSearch}/>}
                                key={`view-${row.id}`}
                                clicked={(event) => this.props.detailsHandler(event, 'show', row.id)}
                            />
                        );
                    }

                    output = [viewButton, editButton, groupButton];
                    return output;
                },
                headerStyle: () => {
                    return {width: '115px'};
                }
            }
        ];
        /* ======================== datatables data assign [END] ======================== */

        return (
            <Auxiliary>
                {this.state.isOpen && (
                    <Lightbox
                        mainSrc={this.state.currentImage}
                        onCloseRequest={() => this.setState({ isOpen: false })}
                    />
                )}
                <div className="breadcrumb-header justify-content-between">
                    <div className="my-auto">
                        <div className="d-flex">
                            <h4 className="content-title mb-0 my-auto text-muted mt-1 tx-13 ml-2 mb-0">
                                {t("side-bar.slot_free_spin")}
                            </h4>
                        </div>
                    </div>
                </div>
                <div className="row row-sm">
                    <div className="col-xl-12">
                        <div className="card card-body card-primary">
                           <div className="">
                                {this.props.loading ? (
                                    <Skeleton count={2} />
                                ) : (
                                    <div className={`form-horizontal filter-function row filter-wrapper-2`}>
                                        <div className="col-md-4 col-6">
                                            <div className="form-group">
                                                <label className="font-weight-bolder">
                                                    {t("global.created-time")}
                                                </label>
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text">
                                                        <i className="fas fa-calendar-check" />
                                                    </span>
                                                    <DateTimePicker
                                                        id='transaction_date'
                                                        name='transaction_date'
                                                        className='form-control filter-input'
                                                        range={true}
                                                        timePicker={true}
                                                        value={this.props.filter.date}
                                                        onChange={this.props.onInputChange}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4 col-6">
                                            <div className="form-group">
                                                <label className="font-weight-bolder">
                                                    {t("slot-free-spin.game-vendor")}
                                                </label>
                                                <select
                                                    className="form-control filter-input"
                                                    id="vendor"
                                                    name="vendor"
                                                    onChange={this.props.onInputChange}
                                                    value={this.props.filter.vendor}
                                                >
                                                    <option value=""></option>
                                                    {this.props.ddVendor &&
                                                    this.props.ddVendor.map((val, idx) => {
                                                        return (
                                                            <option key={val.id} value={val.id}>
                                                                {t(`vendor.${val.slug}`)}
                                                            </option>
                                                        );
                                                    })}
                                                </select>
                                            </div>
                                        </div>
                                        <br/>
                                        <div className="col-md-4 col-6">
                                            <div className="form-group">
                                                <label className="font-weight-bolder">
                                                    {t("slot-free-spin.reference-code")}
                                                </label>
                                                <StringInput
                                                    id="reference_code"
                                                    name="reference_code"
                                                    value={this.props.filter.reference_code}
                                                    onChange={this.props.onInputChange}
                                                    className="filter-input"
                                                    onSearchPress={(evt) =>
                                                        evt.key === "Enter" &&
                                                        this.props.refreshHandler()
                                                    }
                                                />
                                            </div>
                                        </div>
                                        <div className="col mt-auto">
                                            <div>
                                            <Button
                                                typeButton="button"
                                                classValue="btn btn-blue"
                                                idValue="filter"
                                                buttonName={t("global.filter")}
                                                clicked={() =>
                                                    this.props.refreshHandler()
                                                }
                                            />
                                            &nbsp;
                                            <Button
                                                typeButton="button"
                                                classValue="btn btn-secondary"
                                                idValue="reset"
                                                buttonName={t("global.reset")}
                                                clicked={() =>
                                                    this.props.clearHandler()
                                                }
                                            />
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="card">
                            <div className="d-flex align-items-end">
                                <div className="card-header pb-0">
                                    <div className="d-flex justify-content-between">
                                        <h4 className="card-title mg-b-0">
                                            {t("slot-free-spin.listing")}
                                        </h4>
                                    </div>
                                </div>
                                {permission.includes("slot_free_spin_create") && (
                                <div className="d-flex">
                                    <div>
                                        <div className="btn-group">
                                            <AiFillPlusCircle />
                                            <Button
                                                typeButton="button"
                                                classValue="btn btn-underline"
                                                idValue="create"
                                                buttonName={t("slot-free-spin.add-free-spin")}
                                                clicked={() => this.props.changePageHandler("create")}
                                            />
                                        </div>
                                    </div>
                                </div>
                                )}
                            </div>
                            <div className="card-body">
                                <div className="table-responsive table-hover datatable">
                                    <DataTable
                                        keyField="no"
                                        data={this.props.data}
                                        columns={columns}
                                        activePage={this.props.activePage}
                                        limit={this.props.limit}
                                        totalItems={this.props.totalRecords}
                                        paginationHandler={(val) => this.props.datatablesChangeHandler(val,"activePage")}
                                        sizePerPageHandler={(val) => this.props.datatablesChangeHandler(val,"limit")}
                                        searchChangeHandler={this.props.onInputChange}
                                        searchValue={this.props.searchValue}
                                        classValue="dataTable table-bordered text-justify text-center"
                                        loading={this.props.loading}
                                        searchPressSubmitHandler={this.props.searchKeyPressHandler}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Auxiliary>
        );
    }
}

export default withNamespaces("translation")(SlotFreeSpinListing);
